import React, { Component } from 'react';
import { BASE_URL } from '../../constants/Common';

class MoviesMediaUI extends Component {

    showMoreDetail = dataDetail => {
        let result = '';
        if (dataDetail.length) {
            dataDetail.map((detail, index) => {
                if (detail.name) result += detail.name + ', ';
                return null;
            });
        }
        return result.slice(0, -2);
    }

    showGenre = dataGenre => {
        let result = '';
        if (dataGenre.length) {
            dataGenre.map((genre, index) => {
                if (genre.name && genre.genre === 2) result += genre.name + ', ';
                return null;
            });
        }
        return result ? result.slice(0, -2) : 'Không có';
    }

    render () {

        let { dataMedias } = this.props;
        let episodesCurent = dataMedias.episodesCurent ? dataMedias.episodesCurent : 0;
        let episodesMax = dataMedias.episodesMax ? dataMedias.episodesMax : 0;

        return (
            <div className="unit">
                <div className="img">
                    <img src={ dataMedias.img } alt={ dataMedias.img } />
                </div>
                <div className="name">
                    <span>{ dataMedias.name }</span>
                </div>
                <div className="sub-name">
                    <img src={ BASE_URL + 'images/icon-play.png' } alt="true" />
                    <span>{ dataMedias.name }</span>
                    {
                        dataMedias.scoreImdb ?
                        <div>
                            IMDb: <span className="point">
                                {dataMedias.scoreImdb}
                            </span>
                        </div> : null
                    }
                    {
                        episodesCurent || episodesMax ?
                        <div>
                            Tập: {
                                `${episodesCurent}/${episodesMax}`
                            }
                        </div> : null
                    }
                    {
                        dataMedias.categories && dataMedias.categories.length ?
                        <div>Thể loại: { this.showGenre(dataMedias.categories) }</div> :
                        null
                    }
                    {
                        dataMedias.nations && dataMedias.nations.length ?
                        <div>Quốc gia: { this.showMoreDetail(dataMedias.nations) }</div> :
                        null
                    }
                    {
                        dataMedias.languages && dataMedias.languages.length ?
                        <div>Ngôn ngữ: { this.showMoreDetail(dataMedias.languages) }</div> :
                        null
                    }
                </div>
            </div>
        );
    }
}

export default MoviesMediaUI;



// WEBPACK FOOTER //
// ./src/components/CommonComponents/MoviesMediaUI.js